import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { runRtkQuery } from '../helperFn';
import { downloadFile } from '../../utilities/HelperFunctions';

export const reportApi = createApi({
  reducerPath: 'reportApi',
  baseQuery: baseQuery,
  tagTypes: ['accountList'],
  endpoints: (builder) => ({
    getReportAccountList: builder.query({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(
          payload,
          dispatch,
          queryFulfilled,
          'getReportAccountList'
        );
      },
      providesTags: ['reportAccountList'],
    }),
    getDeviceReportFile: builder.query({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        const res = await runRtkQuery(
          payload,
          dispatch,
          queryFulfilled,
          'getDeviceReportFile'
        );
        console.log('DEVICE REPORT RESPONSE: ', res);
        console.log('payload', payload);
        await downloadFile(res.data.addition.download_link, {
          id: payload.payload.account_id,
          title: 'DeviceReport',
        });
      },
    }),
    getTransactionReportFile: builder.query({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        const res = await runRtkQuery(
          payload,
          dispatch,
          queryFulfilled,
          'getTransactionReportFile'
        );
        console.log('TRANSACTION REPORT RESPONSE: ', res);
        await downloadFile(res.data.addition.download_link, {
          id: payload.payload.account_id,
          start_date: payload.payload.date_start,
          end_date: payload.payload.date_end,
          title: 'TransactionReport',
        });
      },
    }),
  }),
});

export const {
  useLazyGetReportAccountListQuery,
  useGetReportAccountListQuery,
  useLazyGetDeviceReportFileQuery,
  useGetDeviceReportFileQuery,
  useLazyGetTransactionReportFileQuery,
  useGetTransactionReportFileQuery,
} = reportApi;
